import { Box } from "@chakra-ui/react";
import { FC, useMemo } from "react";

import { PageLayout } from "~/src/components/features/global/PageLayout";

export type Props = {
  siteSlug: string;
};

export const PopupImportPage: FC<React.PropsWithChildren<Props>> = ({
  children,
  siteSlug,
}) => {
  const breadcrumbs = useMemo(
    () => [
      { label: "ポップアップ", path: `/sites/${siteSlug}/popup_groups` },
      {
        label: "ポップアップCSVインポート",
        path: `/sites/${siteSlug}/popup_groups/import`,
      },
    ],
    [siteSlug]
  );

  return (
    <PageLayout title="ポップアップCSVインポート" breadcrumbs={breadcrumbs}>
      <Box mt="32px">{children}</Box>
    </PageLayout>
  );
};
